import React from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { SERVER_URL } from "../../constants/global";
import Link from "@mui/material/Link";
import { Link as RouterLink } from "react-router-dom";
import { routeConfigs } from "../../navigation/routeConfig";
import { pageTitleSx } from "../../constants/designTokens";

interface PharmacyBusinessInformationProps {
  data: any;
}

const PharmacyBusinessInformation: React.FunctionComponent<PharmacyBusinessInformationProps> = ({
  data,
}) => {
  const irsDefaultFile = data.PharmacyFiles?.find((file: any) => file.File.type === "irs147CLetter");

  return (
    <Box>
      <Typography
        id="business-information-section"
        component="h1"
        sx={{ ...pageTitleSx, mb: 3, display: "flex", alignItems: "center" }}
      >
        Business Information
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <Box>
          {irsDefaultFile?.File?.key ? (
            <Link href={`${SERVER_URL}/file/${irsDefaultFile.File.key}`} color="inherit" target="_blank">
              147c (confirmation letter from IRS)
            </Link>
          ) : (
            <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
              No IRS 147c letter on file.
            </Typography>
          )}
        </Box>
        <Box
          sx={{
            p: 2,
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: 2,
            bgcolor: "rgba(37, 99, 235, 0.04)",
          }}
        >
          <Typography sx={{ fontWeight: 600, mb: 1 }}>Payout bank account</Typography>
          <Typography sx={{ fontSize: 14, lineHeight: 1.5 }}>
            Bank account details for sell-order payouts are managed under{" "}
            <Link
              component={RouterLink}
              to={`${routeConfigs.bankAccount.path}?section=payout`}
              underline="hover"
            >
              Settings → Bank Info → Payout Method
            </Link>
            .
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default PharmacyBusinessInformation;
